'use strict';
import React from 'react';
import CheckoutCartItem from 'checkout/cart/checkoutCartItem';

export default class CheckoutCart extends React.Component {
    render() {
        let {cart, actions} = this.props;
        return (
            <div className="checkout__cart">
                <table>
                    <thead>
                        <tr>
                            <th></th>
                            <th>Artikel</th>
                            <th>Stück</th>
                            <th>Preis/Stück</th>
                            <th>Summe</th>
                            {!this.props.readOnly && <th></th>}
                        </tr>
                    </thead>
                    <tbody>
                    {cart.get('products').map((product, ix) => {
                        return <CheckoutCartItem key={ix} readOnly={this.props.readOnly} actions={actions} product={product} />
                    })}
                    </tbody>
                </table>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./static/app/checkout/cart/checkoutCart.jsx